$('.product-add-cart-button').on('click', function (e) {
    let id = $(this).data('variantid') || $(this).data('id');
    addCartFn(id)
})

var swiper = new Swiper(".m10LiteSwiper", {
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".m10-lite-swiper-pagination",
    }
  });


  var swiper = new Swiper(".m10-lite-module9-swiper", {
    slidesPerView: isMobile() ? 1.4 : 4,
    spaceBetween: isMobile() ? 8 : 24,
    scrollbar: {
      el: ".m10-lite-module9-swiper .swiper-scrollbar",
    }
  });


  $('.tb-product-spec-box dt').click(function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    } else {
      $(this).addClass('active');
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    }
  })

  $('.tb-product-data-title.down').click(function () {
    if ($(this).next().is(':hidden')) {
      $(this).next().slideDown();
      $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
    } else {
      $(this).next().slideUp();
      $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
    }
  })


  // m10-lite-ad 头部倒计时
if ($("#m10-lite-ad-countdown").length > 0) {
  $.ajax({
    url: 'https://backend.turboant.com/index/api/getCountdownTime',
    type: 'get',
    data: {
      page: 'https://turboant.com/pages/best-electric-scooter-for-campus'
    },
    dataType: 'json',
    success: (res) => {
      if (res.data.status === 1) {
        let time = res.data.time;
        $(`#m10-lite-ad-countdown`).timeTo({
          timeTo: new Date(time),
          theme: "black",
          displayDays: 2,
          displayCaptions: true,
          fontSize: !isMobile() ? 30 : 18,
          captionSize: !isMobile() ? 14 : 12,
          lang: 'en',
          countdown: true,
          languages: {
            en: {
              days: 'DAY',
              hours: 'HRS',
              min: 'MIN',
              sec: 'SEC',
            }
            
          }
        });
      }
    }
  });
}

if ($("#m10-lite-ad-countdown-wap").length > 0) {
  $.ajax({
    url: 'https://backend.turboant.com/index/api/getCountdownTime',
    type: 'get',
    data: {
      page: 'https://turboant.com/pages/v8-electric-scooter-for-heavy-adults'
    },
    dataType: 'json',
    success: (res) => {
      if (res.data.status === 1) {
        let time = res.data.time;
        $(`#m10-lite-ad-countdown-wap`).timeTo({
          timeTo: new Date(time),
          theme: "black",
          displayDays: 2,
          displayCaptions: true,
          fontSize: !isMobile() ? 30 : 20,
          captionSize: !isMobile() ? 14 : 12,
          lang: 'en',
          countdown: true,
          languages: {
            en: {
              days: '',
              hours: '',
              min: '',
              sec: '',
            }
            
          }
        });
      }
    }
  });
}

var swiper = new Swiper(".m10-lite-module5-swiper", {
  slidesPerView: 1.3
});

var swiper = new Swiper(".m10-lite-module7-swiper", {
  slidesPerView: 1.4,
  spaceBetween: isMobile() ? 8 : 16,
  scrollbar: {
    el: ".m10-lite-module7-swiper .swiper-scrollbar",
  }
});